<template>
  <div>
    <b-navbar toggleable="lg" type="light" v-if="isUserAccount">
      <b-navbar-brand href="#" class="onco-logo">
        <img
          class="logo"
          alt="Proxy-med"
          src="../assets/ProxyMed_Logo_RGB.svg"
        />
        <OnboardingTour ref="staticTour" :auto-start="false" />
      </b-navbar-brand>

      <!-- Take a Tour — absolutely centered -->
      <div class="tour-center">
        <button class="btn-take-tour" @click="restartTour">
          <svg class="tour-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
          <span>Take a Tour</span>
          <svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </button>
      </div>

      <!-- User dropdown — right -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template #button-content>
            <svg class="user-avatar" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="50" height="50" rx="25" fill="#F0EDE6"/>
              <path d="M33 33V31C33 29.9391 32.5786 28.9217 31.8284 28.1716C31.0783 27.4214 30.0609 27 29 27H21C19.9391 27 18.9217 27.4214 18.1716 28.1716C17.4214 28.9217 17 29.9391 17 31V33" stroke="#C0BCB5" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
              <path d="M25 23C27.2091 23 29 21.2091 29 19C29 16.7909 27.2091 15 25 15C22.7909 15 21 16.7909 21 19C21 21.2091 22.7909 23 25 23Z" stroke="#C0BCB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="user-greeting">{{ greeting }}</span>
          </template>
          <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>


<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Account } from "@/entities/auth/Account";
import { Role } from "@/entities/auth/Role";
import OnboardingTour from '@/components/OnboardingTour.vue'


@Component({
  components: {
    OnboardingTour
  }
})
export default class AppUserNavigation extends Vue {

  get isUserAccount() {
    const account: Account = this.$store.getters["authentication/account"];
    return  account.role === Role.User;
  }

  isActive(route: string): string {
    return this.$route.path === route ? "active" : "";
  }

  get isMenuOpened() {
    return this.$store.state.menu.isOpened;
  }

  onToggleMenu() {
    this.$store.dispatch("menu/toggleMenu");
  }

  created() {
    const mobile = window.matchMedia("screen and (max-width: 576px)");
    mobile.addListener(media => {
      if (!media.matches) return;
      this.$store.dispatch("menu/closeMenu");
    });
  }

  get greeting() {
    const account: Account = this.$store.getters["authentication/account"];
    return account.name + " " + account.surname;
  }

  logout(): void {
    this.$store.dispatch("authentication/logout");
    localStorage.removeItem('result_view_count');
    localStorage.removeItem('currentBranchId');
    localStorage.setItem('fillSurvey', 'false');
  }

  private restartTour(): void {
    const tour = this.$refs.staticTour as any;
    if (tour) {
      tour.resetTour();
    }
  }
}
</script>

<style scoped lang="scss">

/* ── Override Bootstrap collapse — always stay in one row ── */
::v-deep .navbar {
  flex-wrap: nowrap !important;
  position: relative;
  background: linear-gradient(270.06deg, #eaeff8 0.05%, #e7edf7 21.28%, #e7edf7 99.44%);
  border-bottom-color: #2F45A5;
  border-bottom-width: calc(2px + 20%);
  padding: 0.4rem 1rem;
}

::v-deep .navbar-collapse {
  display: flex !important;
  flex-basis: auto !important;
  flex-grow: 0 !important;
}

::v-deep .navbar-nav {
  flex-direction: row !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
}

::v-deep .nav-item {
  display: flex;
  align-items: center;
}

/* Dropdown toggle — keep children in one row */
::v-deep .dropdown-toggle {
  display: flex !important;
  align-items: center !important;
  padding: 0.25rem 0 !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  white-space: nowrap;
}

/* Remove Bootstrap's auto caret */
::v-deep .dropdown-toggle::after {
  display: none !important;
}

/* ── Logo ── */
.onco-logo {
  padding: 0.25rem 0.5rem;
  margin: 0;
  flex-shrink: 0;
}

.logo {
  height: 2.5rem;
}

/* ── Take a Tour — right on desktop, centered on mobile ── */
.tour-center {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 1rem;
}

::v-deep .navbar-nav {
  margin-left: 0 !important;
}

.btn-take-tour {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 13px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}

.btn-take-tour::before {
  content: '';
  position: absolute;
  top: 0; left: -100%;
  width: 100%; height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}
.btn-take-tour:hover::before { left: 100%; }

.btn-take-tour:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.btn-take-tour:active {
  transform: translateY(0);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.tour-icon {
  flex-shrink: 0;
  animation: pulse 2s ease-in-out infinite;
}

.arrow-icon {
  flex-shrink: 0;
  transition: transform 0.3s;
}
.btn-take-tour:hover .arrow-icon { transform: translateX(4px); }

/* ── User avatar + name ── */
.user-avatar {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.user-greeting {
  margin-left: 8px;
  color: black;
  font-family: 'Albert Sans', sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.6; }
}

/* ── Tablet (≤768px) ── */
@media (max-width: 768px) {
  .tour-center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-left: 0;
    margin-right: 0;
  }

  ::v-deep .navbar-nav {
    margin-left: auto !important;
  }

  .logo { height: 2rem; }

  .user-avatar { width: 36px; height: 36px; }

  .btn-take-tour {
    padding: 6px 10px;
    font-size: 12px;
    gap: 5px;
    border-radius: 10px;
  }

  .tour-icon { width: 15px; height: 15px; }
  .arrow-icon { width: 12px; height: 12px; }

  .user-greeting {
    font-size: 13px;
    margin-left: 5px;
  }
}

/* ── Mobile (≤480px) ── */
@media (max-width: 480px) {
  ::v-deep .navbar { padding: 0.3rem 0.6rem; }

  .logo { height: 1.65rem; }

  .onco-logo { padding: 0.15rem 0.25rem; }

  .user-avatar { width: 28px; height: 28px; }

  .btn-take-tour {
    padding: 5px 8px;
    font-size: 11px;
    gap: 4px;
    border-radius: 8px;
  }

  .tour-icon { width: 13px; height: 13px; }
  .arrow-icon { width: 11px; height: 11px; }

  .user-greeting {
    font-size: 11px;
    margin-left: 4px;
  }
}
</style>
